import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { cookie } from '@ifeng-fe/ui_base';
import { getReadNumNormal } from '@src/services/api';
import { getParam } from '@src/utils/utils';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import { wapactPageCount } from 'ThreeTerminal_utils';

class CutOff extends React.PureComponent {
    static propTypes = {
        cutofffConfig: PropTypes.object,
        showCutOffHandle: PropTypes.func,
        isShowCutOff: PropTypes.bool,
    };

    state = {
        readNum: 0,
        wxLaunchHackData: {},
        plan: 'a',
    };

    isSendUnlock = false;

    componentDidMount() {
        const { cutofffConfig } = this.props;
        const userid = getParam('userid', location.search);
        const plan = getParam('plan', location.search) || '';

        if (cutofffConfig?.isHitBlack) {
            return false;
        }

        if (cutofffConfig?.isCutoff || userid) {
            this.goCutoffHandle();
        }

        if (plan) {
            this.setState({
                plan,
            });
        }

        this.callupConfig();
    }

    isCallupQuickapp = () => {
        const { cutofffConfig = {} } = this.props;
        const { isPCCallQuickapp, isMobileCallQuickapp, cutoffIds = [], base62Id = '', wemediaEAccountId } = cutofffConfig;
        const UA = typeof navigator === 'object' ? navigator.userAgent.toLocaleLowerCase() : '';
        const userid = typeof navigator === 'object' ? getParam('userid', location.search) : '';
        let isArticleCallQuick = false;

        cutoffIds.forEach((item) => {
            if (item?.id === wemediaEAccountId && item?.isCallQuickapp) {
                isArticleCallQuick = true;
            }
        });

        if (
            ((isPCCallQuickapp === '2' && userid) || isMobileCallQuickapp === '2') &&
            UA.includes('huawei') &&
            isArticleCallQuick
        ) {
            return true;
        } else {
            return false;
        }
    };

    callupConfig = () => {
        const userid = getParam('userid', location.search) || '';
        const plan = getParam('plan', location.search) || '';
        const { cutofffConfig } = this.props;
        const callupHostUrl = `https://ishare.ifeng.com/loc/webdaoliu/unlock?userid=${userid}&type=${cutofffConfig?.type}&base62Id=${cutofffConfig?.base62Id}&plan=${plan}`;
        let kind = 'inter_dl01';
        let download = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7253767315808845824';
        let downloadAd = 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9156';
        const useridString = userid ? `userid=${userid}` : '';

        if (plan === 'normal') {
            kind = 'inter_dl01';
            download = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7253767315808845824';
            downloadAd = 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9156';
        } else if (plan === 'a') {
            kind = 'inter_dl02';
            download = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7253767569211916288';
            downloadAd = 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9157';
        } else if (plan === 'b') {
            kind = 'inter_dl04';
            download = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7259947069373167616';
            downloadAd = 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9164';
        } else {
            kind = 'inter_dl03';
            download = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7259757839556551680';
            downloadAd = 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9163';
        }

        this.setState({
            wxLaunchHackData: {
                callAppConfig: {
                    docType: 'web',
                    pid: callupHostUrl,
                    kind,
                    noKindFrom: 1,
                    download,
                    downloadAd,
                    failCallback: this.isCallupQuickapp() ? () => {
                        const from = plan ? 'pcArticle' : 'mobileArticle';

                        if (plan === 'normal') {
                            wapactPageCount({
                                value: 'pc_smallqr_kyy_dl',
                                method: 'get',
                            });
                        } else if (plan === 'a') {
                            wapactPageCount({
                                value: 'pc_bigqr_kyy_dl',
                                method: 'get',
                            });
                        } else if (plan === 'b') {
                            wapactPageCount({
                                value: 'pc_bigqr_kyy_dl_b',
                                method: 'get',
                            });
                        } else {
                            wapactPageCount({
                                value: 'wap_kyy_dl',
                                method: 'get',
                            });
                        }

                        location.href = `https://hapjs.org/app/com.ifenghuawei.ds/pages/article?id=ucms_${cutofffConfig?.base62Id}&type=doc&from=${from}&plan=${plan}&${useridString}`;
                    } : null
                },
                callAppClick: () => {
                    if (plan === 'normal') {
                        wapactPageCount({
                            value: 'pc_smallqr_pop_y',
                            method: 'get',
                        });
                    } else if (plan === 'a') {
                        wapactPageCount({
                            value: 'pc_bigqr_pop_y',
                            method: 'get',
                        });
                    } else if (plan === 'b') {
                        wapactPageCount({
                            value: 'pc_bigqr_pop_y_b',
                            method: 'get',
                        });
                    } else {
                        wapactPageCount({
                            value: 'wap_seeall_y',
                            method: 'get',
                        });
                    }
                }
            }
        });
    };

    getReadNumHandle = async () => {
        const { cutofffConfig } = this.props;
        let publishTime = cutofffConfig?.createTime?.replace(/-/g, '/');

        publishTime = new Date(publishTime).getTime() || new Date().getTime();
        publishTime = Math.floor(publishTime / 1000);
        const readNum = await getReadNumNormal(cutofffConfig?.base62Id, publishTime);

        this.setState({
            readNum,
        });
    };

    goButtonHandle = () => {
        const userid = getParam('userid', location.search);

        if (this.isCallupQuickapp() && userid) {
            wapactPageCount({
                value: 'kyy_seeall_pop_yy',
            });
        }
    };

    goCutoffHandle = async () => {
        const userid = getParam('userid', location.search);
        const plan = getParam('plan', location.search) || '';
        const { cutofffConfig } = this.props;
        let cutoffGrayNum = cookie.get('cutoffGrayNum');

        if (!cutoffGrayNum) {
            cutoffGrayNum = Math.floor(Math.random() * 100) + 1;

            cookie.set(
                'cutoffGrayNum',
                cutoffGrayNum,
                '',
                '',
                new Date(new Date().toLocaleDateString()).getTime() + 24 * 30 * 60 * 60 * 1000 - new Date().getTime(),
            );
        }
        if (!userid) {
            // 获取0-100的随机数
            if (!cutofffConfig?.isCutoff || parseInt(cutoffGrayNum) > cutofffConfig?.cutoffGray || !cutofffConfig?.cutoffGray) {
                return false;
            }
        }
        
        this.props.showCutOffHandle(true);
        this.getReadNumHandle();

        if (plan === 'normal') {
            // PC端节流二维码
            wapactPageCount({
                value: 'pc_smallqr_pop',
                method: 'get',
            });
        } else if (plan === 'a') {
            // PC端弹窗二维码
            wapactPageCount({
                value: 'pc_bigqr_pop',
                method: 'get',
            });
        } else if (plan === 'b') {
            // PC端弹窗方案b二维码
            wapactPageCount({
                value: 'pc_bigqr_pop_b',
                method: 'get',
            });
        } else {
            // 手凤端命中用户
            wapactPageCount({
                value: 'wap_seeall_pop',
                method: 'get',
            });
        }
    };

    render() {
        const { readNum, wxLaunchHackData, plan } = this.state;
        const { cutofffConfig, isShowCutOff } = this.props;

        return (
            isShowCutOff && (
                <>
                    {plan === 'b' ? (
                        <div
                            className={styles.articleCutoff}>
                            <div className={styles.articleTitle}>
                                <div className={styles.articleTitleFont}>{cutofffConfig.title}</div>
                                <div className={styles.articleShadow} />
                            </div>
                            {readNum ? (
                                <div className={styles.articleShadowNum}>
                                    <div className={styles.articleShadowText}>
                                        已有<span className={styles.articleShadowTextRed}>{readNum}</span>人解锁该文章
                                    </div>
                                </div>
                            ) : null}
                            <div className={styles.articleCutoffTipBoxB}>
                                <div className={styles.articleCutoffTipButton}>点击看全文</div>
                            </div>

                            {wxLaunchHackData?.callAppConfig && (
                                <WxLaunchHack content={wxLaunchHackData} />
                            )}
                        </div>
                    ) : (
                        <div
                            className={styles.articleCutoff}>
                            <div className={styles.articleTitle}>
                                <div className={styles.articleTitleFont}>{cutofffConfig.title}</div>
                                <div className={styles.articleShadow} />
                            </div>
                            {readNum ? (
                                <div className={styles.articleShadowNum}>
                                    <div className={styles.articleShadowText}>
                                        已有<span className={styles.articleShadowTextRed}>{readNum}</span>人解锁该文章
                                    </div>
                                </div>
                            ) : null}
                            <div className={styles.articleCutoffTipBox}>
                                <div className={styles.articleCutoffTipText}>解锁文章需手机已安装凤凰新闻App</div>
                                <div className={styles.articleCutoffTipText}>
                                    未安装APP用户，点击下方按钮安装后重新扫码即可
                                </div>
                                <div className={styles.articleCutoffTipButton}>点击此处，最后一步解锁文章</div>
                            </div>
                            <div className={styles.articleCutoffVip}>打开APP还能免费得VIP权益</div>
                            <img
                            
                                className={styles.articleCutoffTipPic}
                                src="https://x0.ifengimg.com/ucms/2024_20/B7296BC01A844356045A9AC438A5346E62A2437B_size155_w694_h274.png"
                            />
                            {wxLaunchHackData?.callAppConfig && (
                                <WxLaunchHack content={wxLaunchHackData} />
                            )}
                        </div>
                        
                    )}
                </>
            )
        );
    }
}

export default errorBoundary(CutOff);
